import type { CSSProperties, ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  style?: CSSProperties;
  className?: string;
  variant?: 'default' | 'card';
}

export default function EmptyState({ icon = '📭', title, description, action, style, className, variant = 'default' }: EmptyStateProps) {
  return (
    <div
      className={className}
      style={{
        padding: '40px 20px',
        textAlign: 'center',
        background: variant === 'card' ? 'var(--bg-card)' : 'transparent',
        borderRadius: 'var(--r-xl)',
        border: variant === 'card' ? '1px dashed var(--grey-300)' : 'none',
        ...style,
      }}
    >
      <div
        style={{
          width: 64, height: 64, margin: '0 auto 12px',
          borderRadius: 'var(--r-xl)',
          background: 'var(--color-primary-soft)', color: 'var(--color-primary-dark)',
          display: 'grid', placeItems: 'center', fontSize: 26,
        }}
      >
        {icon}
      </div>
      <div style={{ fontWeight: 700, color: 'var(--text-primary)', fontSize: 16, marginBottom: 4 }}>{title}</div>
      {description && <div style={{ color: 'var(--text-secondary)', fontSize: 14 }}>{description}</div>}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}
